import { put, select, takeLatest } from 'redux-saga/effects'
import { getTripInformationSelector } from '../../../tripInformation/selectors'
import { resetPtsData } from '../pediatricTraumaScore/store/pediatricTraumaScore.actions'
import { resetRTSData } from '../revisedTraumaScore/store/revisedTraumaScore.actions'
import { TripInformationConstants } from '../../../tripInformation/store/tripInformation.constants'
import { getPatientDemographicsSelector } from '../../../patientDemographics/selectors'
import { IPatientDemographicsState } from '../../../patientDemographics/store/patientDemographics.types'
import { isAgeLessThan } from '../../../../utilities/data.util'
import { PatientDemographicsConstants } from '../../../patientDemographics/store/patientDemographics.constants'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* resetTrauma() {
  const tripInformationState = yield select(getTripInformationSelector)
  const { patientCategory } = tripInformationState

  const patientInformationState: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const { age, ageUnit } = patientInformationState
  const showTraumaFlag = Boolean(patientCategory?.show_rts) ?? true

  const ageFlag = age && isAgeLessThan(+age, ageUnit?.id?.toString() || '', 13)
  if (!showTraumaFlag) {
    yield put(resetRTSData())
    yield put(resetPtsData())
  } else if (ageFlag) {
    yield put(resetRTSData())
  } else if (!ageFlag) {
    yield put(resetPtsData())
  }
}

export function* resetTraumaSaga() {
  yield takeLatest(
    [
      TripInformationConstants.SET_TRIP_INFORMATION,
      TripInformationConstants.SET_PATIENT_CATEGORY,
      PatientDemographicsConstants.SET_AGE,
      PatientDemographicsConstants.SET_AGE_UNIT,
      PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS,
    ],
    performWithMutexHOG,
    resetTrauma
  )
}
